import 'wicg-inert';

window.addEventListener('DOMContentLoaded', (event) => {
	const x = window.matchMedia('(min-width: 700px)');

	// TOGGLE GLOSSARY SEARCH
	const searchBar = document.querySelector('.search-bar');
	const searchToggle = document.querySelector('.search-toggle');
	const lettersGroup = document.querySelector('.letters');
	let expanded = false;

	if (searchToggle) {
		const letters = lettersGroup.querySelectorAll('a');

		searchToggle.addEventListener('click', function (event) {
			const parent = this.parentNode;
			const input = document.getElementById('glossaryTerm');

			searchBar.classList.toggle('open');

			expanded = this.getAttribute('aria-expanded') === 'true';
			this.setAttribute('aria-expanded', !expanded);

			if (expanded) {
				input.setAttribute('tabindex', '-1');
			} else {
				input.removeAttribute('tabindex');
			}

			if (x.matches) {
				lettersGroup.inert = !expanded; // disable tabbing through letters behind search bar
			}

			if (input && input.value) {
				input.value = '';
			}
		});

		letters.forEach(function (elem) {
			elem.addEventListener('click', function (event) {
				searchBar.classList.remove('open');
			});
		});
	}
});
